import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'emotion-theming';
import * as serviceWorker from './serviceWorker';

import theme from './theme';

import { Global, css } from '@emotion/core';
import { globalStyles } from './theme';

import App from './App';

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Global styles={css`${globalStyles}`} />
    <App />
  </ThemeProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
